import { BinIcon } from '@icons'
import { Box, Heading, Layer, Text } from 'grommet'
import { Checkmark, Close } from 'grommet-icons'
import { ReactNode } from 'react'
import { Button } from '../Button'

type Props = {
  title: string
  description: string | React.ReactNode
  isLoading?: boolean
  handleSubmit: () => void
  leftIcon?: ReactNode | any
  rightIcon?: ReactNode | any
  onClose: any
  noIcon?: boolean
  headerIcon?: ReactNode
  gridBtn?: boolean
  lBtnLabel?: string
  rBtnLabel?: string
  onLeftBtnClick?: () => void
  className?: string
  modalHeader?: ReactNode
  hideTitle?: boolean
  width?: string
  pad?: any
  descriptionWidth?: string
  buttonPad?: any
  leftBtnClassName?: string
  rightBtnClassName?: string
  additionalButtons?: {
    label: string
    icon?: ReactNode | any
    className?: string
    onClick?: () => void
  }[]
}

export const DeleteModal = ({
  description,
  handleSubmit,
  onClose,
  leftIcon,
  rightIcon,
  title,
  isLoading,
  noIcon,
  lBtnLabel,
  rBtnLabel,
  onLeftBtnClick,
  headerIcon,
  gridBtn,
  className,
  modalHeader,
  hideTitle,
  width,
  pad,
  descriptionWidth,
  buttonPad,
  leftBtnClassName,
  rightBtnClassName,
  additionalButtons
}: Props) => {
  const handleLeftClick = onLeftBtnClick || onClose

  return (
    <Layer
      className={className}
      modal
      onClickOutside={onClose}
      onEsc={onClose}
      position="center"
      style={{ borderRadius: '15px', overflow: modalHeader ? 'hidden' : undefined }}
    >
      <div
        className={`flex max-h-[90vh] w-full flex-col items-stretch ${pad ? pad : 'p-4'} md:max-w-[${width || '500px'}]`}
        style={width ? { maxWidth: width } : undefined}
      >
        <div className="shrink-0">{modalHeader}</div>
        {noIcon ? null : headerIcon ? (
          headerIcon
        ) : (
          <Box align="center" justify="center" margin={{ bottom: 'small' }}>
            <BinIcon />
          </Box>
        )}
        <div
          className={`flex min-h-0 flex-1 flex-col items-center overflow-y-auto p-4 w-full ${
            descriptionWidth ? '' : 'md:max-w-[450px]'
          }`}
          style={descriptionWidth ? { maxWidth: descriptionWidth === '100%' ? '100%' : descriptionWidth } : undefined}
        >
          {hideTitle ? null : (
            <Heading
              color="black"
              level={5}
              margin={noIcon ? { bottom: 'xsmall', top: 'medium' } : 'medium'}
              size="20px"
              textAlign="center"
              weight="400"
            >
              {title}
            </Heading>
          )}

          <div className="flex w-full min-h-0 flex-1 flex-col items-center justify-start">
            {typeof description === 'string' ? (
              <Text color={'#999999'} size="14px" textAlign="center">
                {description}
              </Text>
            ) : (
              <>{description}</>
            )}
          </div>
        </div>
        <div
          className={`flex shrink-0 gap-4 justify-center w-full border-t border-[#F0F0F0] ${gridBtn ? 'flex-col-reverse' : 'flex-row'} ${buttonPad ? buttonPad : 'px-8 py-3.5'}`}
        >
          {additionalButtons &&
            additionalButtons.map((button, index) => (
              <Button
                className={button.className}
                disabled={isLoading}
                icon={button.icon || <Close size="small" />}
                key={index}
                kinds="secondary"
                label={button.label}
                onClick={button.onClick || onClose}
              />
            ))}
          <Button
            className={leftBtnClassName}
            disabled={isLoading}
            icon={leftIcon || <Close size="small" />}
            kinds="secondary"
            label={lBtnLabel || 'No, Keep'}
            onClick={handleLeftClick}
          />
          <Button
            className={rightBtnClassName}
            disabled={isLoading}
            icon={rightIcon || <Checkmark size="small" />}
            isLoading={isLoading}
            label={rBtnLabel || 'Yes, Delete'}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Layer>
  )
}
